/**
 * Standard pieces of information that each landing page includes.
 */
export default [
    {
      id: 0,
      component: 'Home',
      name: '',
      title: 'Home',
      description: 'Welcome to the RI DMV reservation system.'
    },
    {
      id: 1,
      component: 'GetReady',
      name: 'Get ready',
      title: 'Information you need',
      description: 'After renewing online, you will receive your new registration certificate and decals by mail. ' +
        'Please allow two weeks for processing. Print the confirmation page once you ' +
        'have completed your online renewal. This confirmation serves as your proof of registration.'
    },
    {
        id: 2,
        component: 'TransactionInfo',
        name: 'Transaction information',
        title: 'Insurance Information',
        description: ''
      },
      {
        id: 3,
        component: 'TransactionFee',
        name: 'Review',
        title: '',
        description: ''
      },
      {
        id: 4,
        component: 'TransactionCart',
        name: 'Transaction cart',
        title: '',
        description: ''
      },
      {
        id: 5,
        component: 'Payment',
        name: 'Payment',
        title: '',
        description: ''
      },
      {
        id: 6,
        component: 'Confirmation',
        name: 'Confirmation',
        title: '',
        description: ''
      },
  ];
  